export const ACHIEVEMENT_STATUS = {
    EARNED: "EARNED",
    IN_PROGRESS: "IN_PROGRESS",
} as const;

export const GOAL_STATE = {
    IN_PROGRESS: "in_progress",
    COMPLETED: "completed",
} as const;

export type GoalState = typeof GOAL_STATE[keyof typeof GOAL_STATE];

export const SUB_TIER_DISPLAY_STATUS = {
    COMPLETED: "completed",
    CURRENT: "current",
    LOCKED: "locked",
} as const;

export type SubTierDisplayStatus = typeof SUB_TIER_DISPLAY_STATUS[keyof typeof SUB_TIER_DISPLAY_STATUS];

export const ACTIVE_ACHIEVEMENT_STATUSES = [
    ACHIEVEMENT_STATUS.EARNED,
    ACHIEVEMENT_STATUS.IN_PROGRESS,
] as const;

export const DEFAULT_TIER_MILESTONES: any[] = [
    { title: "Recruit", criteria: "Complete 1 Game Mode session" },
    { title: "Veteran", criteria: "Complete 10 Game Mode sessions" },
    { title: "Pro", criteria: "Complete 50 Game Mode sessions" },
];

export const TYPE_COLORS = {
    "weekly": {
        streakBackgroundColor: "#15803D",
        bgGradient: "linear-gradient(88deg, rgba(239, 239, 239, 0.73) 0%, rgba(183, 218, 196, 0.41) 100%)",
    },
    "field-pro1": {
        streakBackgroundColor: "#1D4ED8",
        bgGradient: "linear-gradient(88deg, #EFEFEF 0%, #E7EDFF 100%)",
    },
}